import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export const MultiLineTextCell = ({ text }) => {
  const [height, setHeight] = useState(0);
  const tooltipElement = useRef(null);

  useEffect(() => {
    const heightTemp = tooltipElement.current && tooltipElement.current.offsetHeight;
    if (height) {
      setTimeout(() => {
        setHeight(heightTemp);
      }, 500);
    }
  }, [tooltipElement.current]);

  return (
    <td className="multi-line-td">
      <div className="td-content">
        <span className={classNames('tooltiptext', (height < 60) ? 'tooltip-hide' : '')} >
          <span ref={tooltipElement}>{text}</span>
        </span>
        <div className="ellipsis" >
          {text}
        </div>
      </div>
    </td>
  );
};

MultiLineTextCell.propTypes = {
  text: PropTypes.string,
};

MultiLineTextCell.defaultProps = {
  text: '',
};

export default MultiLineTextCell;



// WEBPACK FOOTER //
// ./src/components/Tables/MultiLineTextCell.js